module.exports = __webpack_public_path__ + "static/media/flat-iron.2eeb09b5.svg";